// NOTE: breakpoints are synced with the @ib-breakpoint-... vars in a variables.less
export const LAYOUT_WIDTH_BREAKPOINTS = {
  xSmall: 359,
  small: 1023,
  medium: 1279,
};
